import React, { useCallback } from "react";
import i18next from "i18next";
import { PopupButton } from "../../Elements/PopupButton";
import { BookmarkList } from "./BookmarkList";
import { getSnapshot } from "./snapshot";
import { getMap } from "../GeoLiteMap";
import { useAppContext } from "../../Contexts/AppContext";
import { useMapContext } from "../../Contexts/MapContext";
import "./BookmarksWidget.scss";

export interface IBookmark {
    id: number;
    name: string;
    extent: number[];
    image: string;
    basemap: string;
}

export const BookmarksWidget = (): JSX.Element => {
    const { bookmarks, setBookmarks, setSelectedBookmarkId } = useAppContext();
    const { baseMap } = useMapContext();

    const addBookmark = useCallback(() => {
        const map = getMap();
        const id = Date.now();
        const bkm: IBookmark = {
            id,
            name: "",
            extent: map.getView().calculateExtent(map.getSize()),
            image: getSnapshot(64, 64),
            basemap: baseMap
        };
        setBookmarks([...bookmarks, bkm]);
        setSelectedBookmarkId(id);
    }, [bookmarks, baseMap]);

    return (
        <div className="scrollable-content-container">
            <div className="scrollable-content">
                <div className="widget-popup-header">
                    <div>{i18next.t("toolBar.bookmarks")}</div>
                </div>
                <BookmarkList />
                <div className="add-bookmark-button">
                    <PopupButton title={i18next.t("bookmarks.addBookmark")} onClick={() => addBookmark()} />
                </div>
            </div>
        </div>
    );
};
